<p-tabs value="{{activeTabIndex}}">
  <p-tablist style="display: flex; align-items: center;">
    <p-tab (click)="handleTabChange(0)" value="0">Consulta General</p-tab>
    <p-tab (click)="handleTabChange(1)" value="1">Consulta Detalle</p-tab>
    <p-tab (click)="handleTabChange(2)" value="2">Consulta Concepto</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel value="0">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="generalHeader" [data]="generalData"
        [previousFilters]="filters" (onRecoverData)="getAllPreInvoicesWithPagination()"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)"
        (onExport)="onExport()"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="1">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="detailHeader" [data]="detailData"
        [previousFilters]="filters" (onRecoverData)="getAllPreInvoiceDetailsWithPagination()"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)"
        (onExport)="onExport()"></app-custom-table>
    </p-tabpanel>
    <p-tabpanel value="2">
      <app-custom-table [showExport]="true" [showRecover]="true" [headers]="conceptHeader" [data]="conceptData"
        [previousFilters]="filters" (onRecoverData)="getAllPreInvoiceConceptsWithPagination()"
        (onPageChange)="onPageChange($event)" (onFilterChange)="onFilterChange($event)"
        (onExport)="onExport()"></app-custom-table>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>